import { render } from "./JobForm.vue?vue&type=template&id=038a47e4&scoped=true"
import script from "./JobForm.vue?vue&type=script&lang=js"
export * from "./JobForm.vue?vue&type=script&lang=js"

import "./JobForm.vue?vue&type=style&index=0&id=038a47e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038a47e4"]])

export default __exports__